module.exports = __webpack_public_path__ + "static/media/tree_21.ad806d58.jpg";